import React, { useContext, useState } from 'react';
import RemoveIcon from 'material-ui/svg-icons/action/delete';


import '../../Base/AwaitableBtn/styles.scss';
import api from 'services';
import { isValidUuid } from 'helpers/miscellaneous';
import { RemoveRowContext } from '../HiresPage';
import withBasicIconButton from '../../TcIndex/Basic/BasicIconButton';
import { showNotification } from 'helpers';

function _Remove({ countIndex, hireDataId }) {
    const removeRow = useContext(RemoveRowContext);
    const [isLoaded, setIsLoaded] = useState(true);

    const remove = () => {
        if (isValidUuid(hireDataId)) {
            removeRow(countIndex);
            setIsLoaded(true);
            return;
        }

        api.updateHireIdeas({ toDelete: [hireDataId] })
            .then((res) => {
                if (res && (!res.errors || !res.errors.length)) {
                    removeRow(countIndex);
                    setIsLoaded(true);
                    showNotification('Removed successfully.', 'success');
                } else {
                    showNotification(res.errors[0].messages[0], 'error');
                }
            });
    };

    return (
        <div className={`awaitable-btn ${isLoaded ? '' : 'wait'}`}>
            {
                isLoaded &&
                    <RemoveIcon 
                        onClick={remove}
                        color='red'
                    />
            }
        </div>
    );
}

export const Remove = React.memo(withBasicIconButton(_Remove));



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/Remove.jsx